import { useState } from 'react';
import { Button } from '../../../../themes/components/Button';
//importing context
import { useAuth } from '../../../../contexts/Auth';
import { useHistory, useLocation } from 'react-router-dom';
import ReactLoading from 'react-loading';

export const Form = () => {
    let history = useHistory();
    let location = useLocation();
    const { realizarLogin, loading } = useAuth();
    const [values, setValues] = useState({ user: '', password: '' });

    function handleChange(event: React.ChangeEvent<any>) {
        const { value, name } = event.target;

        setValues({
            ...values,
            [name]: value
        });
    }

    function handleLogin(){
        realizarLogin(values.user, values.password, history, location);
    }

    const keyPressed = async (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
            handleLogin();
        }
    };

    return (
        <form className="form-objects">
            <div className="form-row">
                <div className="form-group">
                    <label htmlFor="user">Usuário</label>
                    <input type="text" className="form-control" id="user" name="user" onChange={handleChange} value={values.user.substring(0, 42)} onKeyDown={keyPressed} />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label htmlFor="password">Senha</label>
                    <input type="password" className="form-control" id="password" name="password" onChange={handleChange} value={values.password.substring(0, 42)} onKeyDown={keyPressed} />
                </div>
            </div>
            <div className="col-text-center">
                <Button classBtn={"btn btn-primary"} onClick={() => handleLogin()}>
                    {loading ? <div style={{height:"24px"}}><ReactLoading type={"bars"} color={"white"} height={15} width={25} /></div> : "Entrar"}
                </Button>
            </div>
        </form>
    )
}
//style={{marginBottom: '-0.2em'}}/>